export const LEAGUE_SPORT_MAP = {
	// Baseball
	MLB: 'baseball',
	NPB: 'baseball',
	KBO: 'baseball',
	CPBL: 'baseball',

	// Basketball
	NBA: 'basketball',
	NCAAB: 'basketball',
	WNBA: 'basketball',
	'Australia - NBL': 'basketball',
	'China - CBA': 'basketball',
	Euroleague: 'basketball',
	'France - LNB Pro A': 'basketball',
	'Germany - BBL': 'basketball',
	'Italy - Lega Basket Serie A': 'basketball',
	'Korea - KBL': 'basketball',
	'Spain - Liga ACB': 'basketball',
	'Spain - LEB Oro': 'basketball',

	// Soccer
	'Argentina - Primera Division': 'soccer',
	'Argentina - Primera Nacional': 'soccer',
	'Australia - A-League': 'soccer',
	'Austria - 2. Liga': 'soccer',
	'Austria - Bundesliga': 'soccer',
	'Belgium - Jupiler Pro League': 'soccer',
	'Brazil - Serie A': 'soccer',
	'Brazil - Serie B': 'soccer',
	'Brazil - Serie C': 'soccer',
	'Brazil - Copa do Brasil': 'soccer',
	'Canada - Premier League': 'soccer',
	'Chile - Primera Division': 'soccer',
	'China - League One': 'soccer',
	'China - League Two': 'soccer',
	'China - Super League': 'soccer',
	'Colombia - Primera A': 'soccer',
	'Colombia - Primera B': 'soccer',
	'Croatia - 1. HNL': 'soccer',
	'Czech Republic - FNL': 'soccer',
	'Denmark - Superliga': 'soccer',
	'Ecuador - Serie B': 'soccer',
	'England - Championship': 'soccer',
	'England - League 1': 'soccer',
	'England - League 2': 'soccer',
	'England - National League': 'soccer',
	'England - Premier League': 'soccer',
	'Estonia - Esiliiga': 'soccer',
	'Estonia - Esiliiga B': 'soccer',
	'Finland - Veikkausliiga': 'soccer',
	'Finland - Ykkonen': 'soccer',
	'Finland - Ykkosliiga': 'soccer',
	'FIFA - World Cup': 'soccer',
	'France - Ligue 1': 'soccer',
	'France - Ligue 2': 'soccer',
	'Germany - Bundesliga': 'soccer',
	'Germany - Bundesliga 2': 'soccer',
	'Germany - Bundesliga 3': 'soccer',
	'Greece - Super League': 'soccer',
	'Greece - Super League 2': 'soccer',
	'Guatemala - Liga Nacional': 'soccer',
	'Hungary - NB I': 'soccer',
	'India - Super League': 'soccer',
	'Ireland - Division 1': 'soccer',
	'Ireland - Premier League': 'soccer',
	'Israel - Premier League': 'soccer',
	'Italy - Serie A': 'soccer',
	'Italy - Serie B': 'soccer',
	'Italy - Serie C': 'soccer',
	'Japan - J1 League': 'soccer',
	'Japan - J2 League': 'soccer',
	'Japan - J3 League': 'soccer',
	'Kazakhstan - Premier League': 'soccer',
	'Korea - K1 League': 'soccer',
	'Korea - K2 League': 'soccer',
	'Korea - K3 League': 'soccer',
	'Latvia - Virsliga': 'soccer',
	'Lithuania - 1 Lyga': 'soccer',
	'Lithuania - A Lyga': 'soccer',
	'Malaysia - Super League': 'soccer',
	'Mexico - Liga MX': 'soccer',
	'Mexico - Liga de Expansion MX': 'soccer',
	'Mongolia - Premier League': 'soccer',
	'Netherlands - Eerste Divisie': 'soccer',
	'Netherlands - Eredivisie': 'soccer',
	'Norway - 1. Divisjon': 'soccer',
	'Norway - Eliteserien': 'soccer',
	'Poland - Ekstraklasa': 'soccer',
	'Poland - I Liga': 'soccer',
	'Portugal - Primeira Liga': 'soccer',
	'Portugal - Segunda Liga': 'soccer',
	'Romania - Liga I': 'soccer',
	'Romania - Liga II': 'soccer',
	'Russia - Premier League': 'soccer',
	'Saudi Arabia - Saudi League': 'soccer',
	'Scotland - Championship': 'soccer',
	'Scotland - Premiership': 'soccer',
	'Serbia - Super Liga': 'soccer',
	'Singapore - Premier League': 'soccer',
	'Sweden - Allsvenskan': 'soccer',
	'Sweden - Ettan': 'soccer',
	'Sweden - Superettan': 'soccer',
	'Switzerland - Challenge League': 'soccer',
	'Switzerland - Super League': 'soccer',
	'Turkey - 1. Lig': 'soccer',
	'Turkey - Super Lig': 'soccer',
	'Ukraine - Premier League': 'soccer',
	'Uruguay - Primera Division': 'soccer',
	'Uruguay - Segunda Division': 'soccer',
	'Uzbekistan - Super League': 'soccer',
	'USA - MLS Next Pro': 'soccer',
	'USA - Major League Soccer': 'soccer',
	'USA - NISA': 'soccer',
	'USA - NWSL': 'soccer',
	'USA - USL Championship': 'soccer',
	'USA - USL League One': 'soccer',
	'Vietnam - V League 1': 'soccer',
	'UEFA - Champions League': 'soccer',
	'UEFA - Europa Conference League': 'soccer',
	'UEFA - Europa League': 'soccer',
	'CONMEBOL - Copa Libertadores': 'soccer',
	'CONMEBOL - Copa Sudamericana': 'soccer',

	// American football
	CFL: 'football',
	NCAAF: 'football',
	NFL: 'football',
	// Ice hockey
	NCAAH: 'hockey',
	NHL: 'hockey',
	// Tennis
	ATP: 'tennis',
	'ATP Challenger': 'tennis',
	'International - Tours': 'tennis',
	'International - Tours Women': 'tennis',
	WTA: 'tennis',
	// MMA
	UFC: 'mma',
	// Esports
	CS2: 'esports',
	'Dota 2': 'esports',
	'League of Legends': 'esports',
	'Rocket League': 'esports',
	Valorant: 'esports',
	// Golf
	PGA: 'golf',
};